export default "__VITE_ASSET__tZvJx2Ir__"